import { AdminDashboardAppRevenueFilter, AdminDashboardAppRevenueResponse } from '../../graphql/API';
import { adminGetDashboardAppRevenueData } from '../../graphql/queries';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const adminGetDashboardAppRevenueDataApi = async (
  filter: AdminDashboardAppRevenueFilter,
): Promise<AdminDashboardAppRevenueResponse> => {
  const result = await executeGql(adminGetDashboardAppRevenueData, { filter });
  return processGqlResult<AdminDashboardAppRevenueResponse>(
    'adminGetDashboardAppRevenueData',
    result,
  );
};